/* globals $, query, rolling */
import _ from 'underscore'
import * as d3 from 'd3'
import { guff } from 'bam-node-baseball-savant/utils/guff'
import setTextColorWithBackground from 'bam-node-baseball-savant/utils/set-text-color-with-background.ts'

let column = 'xwoba'

if (query.type) {
    column = query.type
    loadOptionHTML(column)
}

$(document).ready(() => {
    $('#container').on('click', '.btn', function handleClick() {
        const id = this.id.split('-')[1]
        $(`.pen-hide-${id}`).toggle()
        $(`.pen-border-${id}`).toggle()

        if ($(`#${this.id}`).text() === 'Show All') {
            $(`#${this.id}`).text('Hide')
        } else {
            $(`#${this.id}`).text('Show All')
        }
    })

    $('.type-link').click(function handleClick() {
        $(this).children('.options').toggle()
        // $('.options').toggle()
    })

    $('.option').click(function handleClick() {
        const { type } = this.dataset
        loadOptionHTML(type)
        window.history.pushState('', '', `?type=${type}`)
        loadAllTables()
    })
})

function loadOptionHTML(columnName) {
    $('.catType').html($(`[data-type="${columnName}"]`).html())
    column = columnName
}

let catbinType = []
// eslint-disable-next-line no-restricted-syntax, guard-for-in
for (const type in rolling) {
    catbinType.push({
        type,
        sort:
            type.indexOf('Pitcher') > -1
                ? Number(rolling[type][0].cat_bin) * 100
                : Number(rolling[type][0].cat_bin),
    })
}

loadAllTables()

function loadAllTables() {
    catbinType = _.sortBy(catbinType, 'sort')

    // $('#container').html('')
    const $containers = $('.flex-column')

    for (let i = 0; i < catbinType.length; i++) {
        const currentColumn = column
        rolling[catbinType[i].type] = _.sortBy(
            rolling[catbinType[i].type],
            (d) => Number(d[`${currentColumn}_delta`])
        )
        if (catbinType[i].type.indexOf('Batter') > -1) {
            rolling[catbinType[i].type].reverse()
        }

        const $el = $($containers.get(i))
        $el.html('')
        createTable(
            $el,
            catbinType[i].type,
            rolling[catbinType[i].type],
            currentColumn
        )
    }
}

function createTable($el, type, data, col) {
    const isPitcher = data[0].type_cat_bin.includes('Pitcher')
    const pitcherPrefix = isPitcher ? 'Pitching ' : ''
    const binSize = data[0].cat_bin
    const category = $('.catType').eq(0).text()

    $el.html(`
            <div style="position: relative;">
                <div style="float: left; width: 75%;"><h6>${pitcherPrefix} ${binSize} PA ${category}</h6>
                </div>
                <div style="float: left; width: 25%; text-align: right;">
                    <div id="show-${type}" class="btn btn-default" style="padding: .1rem .5rem .1rem .5rem;">Show All</div>
                </div>
            </div>
            <table>
                <thead>
                <tr>
                    <th></th>
                    <th style="text-align: center;">THEN</th>
                    <th style="text-align: center;">NOW</th>
                    <th style="text-align: center;">Δ</th>
                </tr>
                </thead>
                <tbody>
                ${data
                    .map((d, i) => {
                        let css = ` pen-show`
                        if (i > 4 && i < data.length - 5) {
                            css = ` pen-hide-${type}`
                        }
                        let hiddenBar = ``

                        if (i === 4) {
                            hiddenBar = `<tr class="pen-border pen-border-${d.type_cat_bin}"><td colspan="4">
                            <div style="margin-top: 1.5rem; border-top: dashed 1px #3a909d; width: 100%;">&nbsp;</div>
                        </td></tr>`
                        }

                        const thenVal = guff(d[`penultimate_x_${col}`], col)
                        const nowVal = guff(d[`last_x_${col}`], col)
                        const rawDelta = d[`${col}_delta`]
                        const deltaVal = guff(rawDelta, col, {
                            isDiff: true,
                        })
                        const arrow = addArrow(rawDelta)
                        const deltaColor = highlightDelta(rawDelta, isPitcher)

                        return `<tr class="${css} pen-${type}" style="border-bottom: 1px solid #fff;">
                                <td>
                                    <img class="table-team-logo-medium" src="https://midfield.mlbstatic.com/v1/team/${d.player_team_id}/spots/108" height="22" width="22">
                                    <img class="player-mug" onerror="this.onerror=null;this.src='https://content.mlb.com/images/headshots/current/60x60/generic.png';" src="https://midfield.mlbstatic.com/v1/people/${d.player_id}/spots/60?zoom=1.2" height="30" width="30">
                                    <a href="/savant-player/${d.slug}?stats=statcast-r-histograms-mlb" target="_blank">${d.player_name}</a></td>
                                <td style="text-align: center;">${thenVal}</td>
                                <td style="text-align: center;">${nowVal}</td>
                                <td style="text-align: center; ${deltaColor}"><span>${deltaVal} ${arrow}</span></td>
                            </tr>${hiddenBar}`
                    })
                    .join('')}
                </tbody>
            </table>                
        `)
}

function addArrow(i) {
    if (Number(i) > 0) {
        return '↑'
    }
    if (Number(i) < 0) {
        return '↓'
    }

    return '–'
}

function highlightDelta(i, isPitcher) {
    const range = ['#3661AD', '#FFFFFF', '#D82129']
    if (isPitcher) {
        range.reverse()
    }

    const color = d3
        .scaleLinear()
        .range(range)
        .domain([-0.25, 0, 0.25])
        .clamp(true)

    const backgroundColor = color(i)

    const textColor = setTextColorWithBackground(backgroundColor)

    return `background-color: ${backgroundColor}; color: ${textColor}`
}
